<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    ></condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
      isShow: false,
    };
  },
  computed: {
    columns() {
      if (this.reportType == "simple") {
        return [
          { name: "BusinessDay" },
          { name: "PeopleType1" },
          { name: "PeopleType2" },
          { name: "PeopleType3" },
          { name: "PeopleType4" },
          { name: "TotalPeople" },
          { name: "Total" },
        ];
      } else {
        return [
          { name: "BusinessDay" },
          { name: "BusinessClass" },
          { name: "SalNumber" },
          { name: "TradeType" },
          { name: "SalTime" },
          { name: "PeopleType1" },
          { name: "PeopleType2" },
          { name: "PeopleType3" },
          { name: "PeopleType4" },
          { name: "TotalPeople" },
          { name: "Total" },
        ];
      }
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getPeople(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getPeople(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printPeople(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getPeople(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
